// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7a91a8a0","455":"3ed194e7","977":"732b0a76"}[chunkId] + ".chunk.js";
};